<div class="w-full h-full bg-[#232323] text-white min-h-screen overflow-auto">
  <!-- Header -->
  <div class="px-8 md:px-16 pt-12 pb-6">
    <div class="flex items-center gap-4 mb-2">
      <div class="p-3 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl shadow-lg shadow-amber-500/20">
        <mat-icon class="material-symbols-outlined text-white icon-size-8">crown</mat-icon>
      </div>
      <h1 class="text-4xl font-extrabold">Minhas Badges</h1>
    </div>
    <p class="text-lg text-white/70 mt-2">
      Conquiste badges completando ações na plataforma. Quanto mais você interagir, mais conquistas você terá!
    </p>
  </div>

  <!-- Conteúdo -->
  <div class="px-8 md:px-16 pb-12">
    <!-- Empty State -->
    <div *ngIf="conquistas.length === 0" class="text-center py-16">
      <div class="w-20 h-20 rounded-full bg-zinc-800 flex items-center justify-center mx-auto mb-4">
        <mat-icon class="material-symbols-outlined text-white/30 icon-size-10">emoji_events</mat-icon>
      </div>
      <h3 class="text-xl font-semibold text-white mb-2">Nenhuma conquista ainda</h3>
      <p class="text-white/50">Complete ações na plataforma para ganhar suas primeiras badges!</p>
    </div>

    <!-- Grid de Badges -->
    <div *ngIf="conquistas.length > 0" class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-6">
      <div *ngFor="let conquista of conquistas"
        class="flex flex-col items-center text-center transition-all rounded-xl p-4 bg-zinc-900 border border-zinc-800 hover:border-[#E4811E]/50"
        [ngClass]="conquista.conquistada ? 'opacity-100' : 'opacity-50'" 
        matTooltip="{{ conquista.obtencao }}">

        <img [src]="conquista.imagemUrl" [alt]="conquista.nome" 
             class="w-24 h-24 object-contain rounded-xl transition-transform"
             [ngClass]="{
               'cursor-pointer hover:scale-105': conquista.conquistada,
               'grayscale brightness-75 cursor-default': !conquista.conquistada
             }"
             (click)="onConquistaClick(conquista)" />

        <p class="mt-3 text-base font-semibold text-center leading-tight"
          [ngClass]="conquista.conquistada ? 'text-white' : 'text-white/60'">
          {{ conquista.nome }}
        </p>
      </div>
    </div>
  </div>
</div>
